import {
  SET_DATA,
  SET_AVAILABLE_FILES,
  SET_FILE_NAME,
  SET_EDIT_VALUES,
  RESET_STATE,
  FILE_SAVED,
  SET_MODIFIED,
  SET_EDITABLE,
  SET_SHAFT_DATA,
  SET_FILE_TYPE,
  SET_SHAFT_JACQUARD,
  SET_REGULATOR,
  SET_CPPP,
  SET_DATA_AVAILABLE
} from "./constants";
import { getInitialState } from "./index";
import eventBus from "../../../src/utils/eventBus";
import uptFile from "../../../src/utils/nonReactiveState/uptFile";

const _ = require("lodash");

export default {
  [SET_EDITABLE](state, value) {
    Object.assign(state, value);
  },

  [SET_EDIT_VALUES](state, { values, selections }) {
    state.isApplyingChanges = true;
    values.map((v, i) => {
      uptFile.pickData.driveData.data[selections[i][0]][selections[i][1]] = v;
    });
    state.modified = true;
    state.isApplyingChanges = false;
    eventBus.$emit("selectionUpdate", selections);
  },

  [SET_DATA](state, newData) {
    uptFile.setUptFile(newData);
    state.dataAvailable = true;
    eventBus.$emit("fileLoaded");
    eventBus.$emit("fullUpdate", { retainScrollPosition: false });
  },

  [SET_DATA_AVAILABLE](state, dataAvailable) {
    state.dataAvailable = dataAvailable;
  },

  [SET_AVAILABLE_FILES](state, availableFiles) {
    state.availableFiles = availableFiles;
  },

  [SET_FILE_NAME](state, fileName) {
    state.fileName = fileName;
  },

  [SET_FILE_TYPE](state, fileType) {
    state.fileType = fileType;
  },

  [RESET_STATE](state) {
    const newState = getInitialState();
    _.forIn(state, (value, key) => {
      state[key] = newState[key];
    });
  },

  [FILE_SAVED](state) {
    state.modified = false;
  },

  [SET_MODIFIED](state, modified) {
    state.modified = modified;
  },

  [SET_SHAFT_DATA](state, { pickIndex, shaftIndex, shaftData }) {
    state.data.pickData.shaftData.data[pickIndex][shaftIndex] = shaftData;
  },

  [SET_SHAFT_JACQUARD](
    _state,
    {
      oldNumberOfJacquardHooks,
      newNumberOfJacquardHooks,
      oldNumberOfShafts,
      newNumberOfShafts
    }
  ) {
    const jacquardDataPickTagIndex = uptFile.xmlData.pickTags.findIndex(
      p => Object.keys(p)[0] === "JacquardData"
    );

    if (oldNumberOfJacquardHooks !== newNumberOfJacquardHooks) {
      if (oldNumberOfJacquardHooks === 0) {
        uptFile.xmlData.pickTags.unshift({
          JacquardData: { bitCount: newNumberOfJacquardHooks }
        });
        uptFile.pickData.jacquardData.tagNames.unshift("JacquardData");
        uptFile.pickData.jacquardData.data = Array.from(
          { length: uptFile.xmlData.patternPicksCount },
          () => Array(newNumberOfJacquardHooks).fill(0)
        );
      } else if (newNumberOfJacquardHooks === 0) {
        uptFile.xmlData.pickTags.splice(jacquardDataPickTagIndex, 1);
        uptFile.pickData.jacquardData.tagNames.splice(0, 1);
        uptFile.pickData.jacquardData.data = [];
      } else {
        uptFile.xmlData.pickTags[
          jacquardDataPickTagIndex
        ].JacquardData.bitCount = newNumberOfJacquardHooks;
        if (newNumberOfJacquardHooks > oldNumberOfJacquardHooks) {
          const numberOfHooksToAdd =
            newNumberOfJacquardHooks - oldNumberOfJacquardHooks;
          uptFile.pickData.jacquardData.data.forEach((_j, i) =>
            uptFile.pickData.jacquardData.data[i].push(
              ...Array(numberOfHooksToAdd).fill(0)
            )
          );
        } else {
          uptFile.pickData.jacquardData.data.forEach((_j, i) =>
            uptFile.pickData.jacquardData.data[i].splice(
              newNumberOfJacquardHooks
            )
          );
        }
      }
    }
    if (oldNumberOfShafts !== newNumberOfShafts) {
      const shaftDataPickTagIndex = uptFile.xmlData.pickTags.findIndex(
        p => Object.keys(p)[0] === "ShaftData"
      );
      if (oldNumberOfShafts === 0) {
        if (jacquardDataPickTagIndex === -1) {
          uptFile.xmlData.pickTags.unshift({
            ShaftData: { bitCount: newNumberOfShafts * 2 }
          });
        } else {
          uptFile.xmlData.pickTags.splice(1, 0, {
            ShaftData: { bitCount: newNumberOfShafts * 2 }
          });
        }
        uptFile.pickData.shaftData.tagNames.unshift("ShaftData");
        uptFile.pickData.shaftData.data = Array.from(
          { length: uptFile.xmlData.patternPicksCount },
          () => Array(newNumberOfShafts).fill(0)
        );
      } else if (newNumberOfShafts === 0) {
        uptFile.xmlData.pickTags.splice(shaftDataPickTagIndex, 1);
        uptFile.pickData.shaftData.tagNames.splice(0, 1);
        uptFile.pickData.shaftData.data.splice(
          0,
          uptFile.pickData.shaftData.data.length
        );
      } else {
        uptFile.xmlData.pickTags[shaftDataPickTagIndex].ShaftData.bitCount =
          newNumberOfShafts * 2;
        if (newNumberOfShafts > oldNumberOfShafts) {
          const numberOfShaftsToAdd = newNumberOfShafts - oldNumberOfShafts;
          uptFile.pickData.shaftData.data = uptFile.pickData.shaftData.data.map(
            p => [...p, ...Array(numberOfShaftsToAdd).fill(0)]
          );
        } else {
          uptFile.pickData.shaftData.data = uptFile.pickData.shaftData.data.map(
            p => p.slice(0, newNumberOfShafts)
          );
        }
      }
    }
    eventBus.$emit("fullUpdate", { retainScrollPosition: true });
  },
  [SET_REGULATOR](state, { pickIndex, newValue }) {
    uptFile.pickData.colorControl.data[pickIndex][1] = newValue;
  },
  [SET_CPPP](state, { picksToUpdate, newPacketSize }) {
    picksToUpdate.forEach(pickIndex => {
      uptFile.pickData.colorControl.data[pickIndex][2] = newPacketSize;
    });
  }
};
